import React, { useEffect, useState } from 'react'
import { Input as ShadcnInput } from '@/components/ui-primitives/input'
import { mergeClasses } from '@/helpers/styling'
import { useFormFieldId } from './form'

export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const defaultId = useFormFieldId()
  return (
    <ShadcnInput
      data-huh-id={defaultId}
      id={defaultId}
      {...props}
      className={mergeClasses(`
        !px-[12px] h-8 rounded-md text-[13px] shadow-none
        bg-white0 border border-border
        focus:ring-2 focus:ring-[#51479e]/40
        focus-visible:ring-2 focus-visible:ring-[#51479e]/40 focus-visible:ring-offset-0`,
        props.className)} />
  )//bg-neutral-100 drop-shadow border-0
}

/**
 * Keep a string state so the input can handle partial / invalid values while typing.
 * Also, [number input is bad](https://n8d.at/inputtypenumber-and-why-it-isnt-good-for-your-user-experience/)
 */
export function NumberInput(props: {
  value: number | null
  onChange: (value: number | null) => void
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange">) {
  const { value, onChange, ...inputProps } = props
  const [ stringValue, setStringValue ] = useState(props.value != null ? String(props.value) : '')

  useEffect(() => {
    setStringValue(props.value != null ? String(props.value) : '')
  }, [ props.value ])

  const setLocalValueAndPublishIfValid = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget.value
    const inputValueAsNumber = parseFloat(inputValue)
    setStringValue(inputValue)
    props.onChange(isNaN(inputValueAsNumber) ? null : inputValueAsNumber)
  }

  return (
    <Input
      type="text"
      pattern={props.pattern || "[0-9]+([.,][0-9]+)?"}
      inputMode={props.inputMode || 'numeric'}
      value={stringValue}
      onChange={setLocalValueAndPublishIfValid}
      {...inputProps}
    />
  )
}